import { AxiosInstance } from "axios";
import { toast } from "react-toastify";

export interface applyCampaignParameters {
  phone: string;
  email: string;
  code: string;
  schoolCampaignInfos?: schoolCampaignInfoType
}
export interface schoolCampaignInfoType {
  schoolCode: string;
  studentName: string;
  studentID: string;
  studentEmail: string;
}
interface applyCampaignResponse {
  err: string;
  cu_id: string;
  message?: string;
  user_name?: string;
}

export const applyCampaign = async (
  axios: AxiosInstance,
  { phone, email, code, schoolCampaignInfos }: applyCampaignParameters
) => {
  const requestData = JSON.stringify(schoolCampaignInfos ? {
    phone,
    email,
    code,
    schoolCampaignInfos
  } : {
    phone,
    email,
    code,
  });

  const headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };
  try {
    const { data } = await axios.post<applyCampaignResponse>(
      "api2/Warrant/ApplyCampaign",
      requestData,
      { headers }
    );
    if (!data) {
      return { err: "9999", cu_id: null, user_name: "" };
    }
    if (data.err !== "0000") {
      toast.error(`進入活動失敗:${"(" + data.err + ")：" + data.message}`, {
        position: "top-right",
        autoClose: 1300,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
    return { ...data };
  } catch (error) {
    (window.parent as any).reactLogout(`登入閒置已超過20分鐘，請重新登入。 Error:${error}`);
    return { err: "9999", cu_id: null, user_name: "" };
  }
};
